export const NOT_ENOUGH_CREDITS_ERROR = 'Not enough credits';

export const PROJECT_CREATE_FAILED = 'Could not create the project. Please try again.';

export const RUN_ANSWER_FAILED = 'Could not send the answer. Please try again.';

export const RUN_TAKEOVER_FAILED = 'The page could not be reached. It may have closed.';

/** Non-fatal: the free-text UUID escape hatch still works without the dropdown. */
export const PROJECT_ACCOUNTS_LOAD_FAILED =
  'Could not load the client list — you can still enter an entity ID.';

export const PROJECT_ENTITY_ID_REQUIRED = "Enter the entity ID or choose 'No client'.";

export const OUT_OF_CREDITS_ERROR_MESSAGE = 'You have run out of credits. Please upgrade your plan to continue.';

export const CHAT_ERROR_MESSAGES = {
  GENERIC: 'I apologize, but I encountered an error processing your request. Please try again.',
  SESSION_EXPIRED: 'Your chat session has expired. Please refresh the page to start a new conversation.',
  EMPTY_MESSAGE: 'Please enter a message before sending.',
  FREE_TIER_MESSAGE_LIMIT: 'You have reached your free message limit. Upgrade to continue chatting.',
} as const;
export const ERROR_MESSAGES = {
  AGENT_USAGE_LOAD_FAILED: 'Failed to load agent usage',
  MARGIN_LOAD_FAILED: 'Failed to load margin',
} as const;
